import {Injectable} from "@angular/core";
import {Http, Response, RequestOptionsArgs, Headers, RequestOptions} from "@angular/http";
import {Observable} from "rxjs/Observable";
import { environment } from './../../environments/environment'
import 'rxjs/add/observable/empty' 
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { unescape } from "querystring";
import { Router } from '@angular/router';

import * as _moment from 'moment';

import * as _ from "lodash";
import { Member } from "../_models";
import { VerifyMemberInfo } from "../_models/verify-member-info";

const moment = _moment;
//import { ReplaySubject } from "rxjs";

@Injectable()
export class ApiService {
    authService: any ={};
    private options : RequestOptions;
    private _baseUrl = "";

    private cache = {
        //productCategories: new  ReplaySubject(1)
        productCategories: []
    }

    constructor(private http : Http, private router: Router) {
        this._baseUrl = environment.apiBaseUrl;
        this.options = new RequestOptions();
        var openIdTokenParams = JSON.parse(localStorage.getItem('openIdTokenParams'));
        if (openIdTokenParams && openIdTokenParams.access_token) {
            this.authService.accessToken = openIdTokenParams.access_token;
        }
    }

    protected getAuthHeader(includeJsonContentType?: boolean): RequestOptions {
 
        var openIdTokenParams = JSON.parse(localStorage.getItem('openIdTokenParams'));
        if (openIdTokenParams && openIdTokenParams.access_token) {
            this.authService.accessToken = openIdTokenParams.access_token;
        }
        
        let headers = new Headers({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", `application/json, text/plain, */*`);

        return new RequestOptions({ headers: headers });
    }



    private handleError(error : Response) {
        if(error.status === 401){
            window.location.href="/login";
        }
        try{
            return Observable.throw(error.json());
        }catch(err){
            return Observable.throw(error);
        }
        
    }

        login(username: string, password: string, productId) {

            var headers = new Headers();
            headers.set('Content-Type', "application/x-www-form-urlencoded");

            let params = new URLSearchParams();
            params.append('username', username)
            params.append('password', password)
            params.append('productId', productId)
            params.append('grant_type', 'urn:ietf:params:oauth:grant-type:la_member_password')
            params.append('scope', 'openid email phone profile offline_access roles')
            params.append('resource', window.location.origin);
    
            let requestBody = params.toString();
    
            return this.http.post(this._baseUrl + 'connect/token', requestBody, { headers: headers })
            .map((response : Response) => {
                return response.json();
            })
            .catch(this.handleError);  
    }

    loginFromAdmin(memberId: string, code: string, productId) {

        var headers = new Headers();
        headers.set('Content-Type', "application/x-www-form-urlencoded");

        let params = new URLSearchParams();
        params.append('username', memberId)
        params.append('password', code)
        params.append('productId', productId)
        params.append('grant_type', 'urn:ietf:params:oauth:grant-type:la_member_from_admin')
        params.append('scope', 'openid email phone profile offline_access roles')
        params.append('resource', window.location.origin);

        let requestBody = params.toString();

        return this.http.post(this._baseUrl + 'connect/token/', requestBody, { headers: headers })
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
}

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentDependent')
        localStorage.removeItem('currentMember');
        localStorage.removeItem('openIdTokenParams');
    }

    verifyMember(productId, verifyMemberInfo: VerifyMemberInfo): Observable <any>{
        return this.http.post(this._baseUrl + 'api/member/verify/' + productId,verifyMemberInfo)
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }

    getMemberById(memberId: string): Observable<any> {
        return this.http.get(this._baseUrl+'/api/member/' + memberId + "?rnd="+new Date().getTime(), this.getAuthHeader(false))
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
        
    }

   me(): Observable<any> {
    return this.http.get(this._baseUrl+'/api/account/users/me', this.getAuthHeader(false))
    .map((response : Response) => {
        return response.json();
    })
    .catch(this.handleError);  
    
}


    create(user: Member) {
        return this.http.post(this._baseUrl+ '/api/member/register', user)
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }

    requestResetPassword(resetPasswordModel:any){
        return this.http.post(this._baseUrl+ '/api/member/reset-password', resetPasswordModel)
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }

    resetPasswordConfirm(id: string, resetPasswordConfirmModel:any){
        return this.http.post(this._baseUrl+ '/api/member/reset-password-confirm/'+ id, resetPasswordConfirmModel)
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }

    updateMember(member: Member){
        return this
        .http
        .put(this._baseUrl+ '/api/member/update', member, this.getAuthHeader(false))
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }

    updateFirstTime(user: Member) {
        var registerEndpoint =  environment.registerEndpoint;
        return this
        .http
        .put(this._baseUrl+ '/api/member/update-first-time/?registerEndpoint='+ registerEndpoint, user, this.getAuthHeader(false))
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }

    verifyAccount(verificationId: string){
        var registerEndpoint =  environment.registerEndpoint;
        return this.http.post(this._baseUrl+ '/api/member/verify-account/'+verificationId , {registerEndpoint})
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }

    verifyResetPasswordAccount(verificationId: string){
        return this.http.get(this._baseUrl+ '/api/member/verify-reset-password-account/'+verificationId )
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }
    
    ssoLogin(memberId:string, productId : number){
       var payloadEndpoint =  environment.payloadEndpoint;
        return this.http.post(this._baseUrl+ '/api/member/sso-login/'+memberId  + "/" + productId, {payloadEndpoint}, this.getAuthHeader(false))
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }

    ssoRFLogin(memberId:string, productId){
         return this.http.get(this._baseUrl + '/api/SSORF/sso-login/'+ memberId + "/" + productId,this.getAuthHeader(false))
         .map((response : Response) => {
             console.log(response);
             return response.json();
         })
         .catch(this.handleError);  
     }

     ssoGenGoldLogin(memberId, productId){
        return this.http.get(this._baseUrl + '/api/ssoGenGold/sso-login/'+ memberId +"/" + productId,this.getAuthHeader(false))
        .map((response : Response) => {
            console.log(response);
            return response.json();
        })
        .catch(this.handleError);  
     }

     ssoMaestroLogin(memberId, productId){
        return this.http.get(this._baseUrl + '/api/ssoMaestro/sso-login/'+ memberId +"/" + productId,this.getAuthHeader(false))
        .map((response : Response) => {
            console.log(response);
            return response.json();
        })
        .catch(this.handleError);  
     }

     memberOauthLogin(productId){
        
        var headers = new Headers();
        headers.set('Content-Type', "application/x-www-form-urlencoded");
        headers.set('Authorization', 'Bearer ' + this.authService.accessToken);
        let params = new URLSearchParams();
        params.append('client_id', "LA_Member_Portal")
        params.append('response_type', "code")
        // params.append('grant_type', 'urn:ietf:params:oauth:grant-type:la_member_password')
        params.append('scope', 'openid email phone profile offline_access roles')
        params.append('redirect_uri', "http://www.mylifewellness.net/oauthcallback");

        let requestBody = params.toString();

        return this.http.post(this._baseUrl + 'connect/authorize/'+ productId, requestBody, { headers: headers })
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }
    
    //Associates
    addAssociates(memberId, productId ,tryCount,addAssociates,){
        var registerEndpoint =  environment.registerEndpoint;
        return this.http.post(this._baseUrl+ '/api/associate/first-time/' + memberId + "/"+ productId+ '/?registerEndpoint='+ registerEndpoint  + "&tryCount=" + tryCount, addAssociates )
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }

    //whitelabels

    getWhitelabels(): Observable<any> {
        return this.http.get(this._baseUrl+'/api/whitelabel/', this.getAuthHeader(false))
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
        
    }
    

    //obsolete
    getWhitelabelConfigsByHostNameAndFeatureName(host: string, feature: string): Observable<any>{
        return this.http.get(this._baseUrl+'/api/whitelabelConfig/host-feature/' + host +'/'+ feature, this.getAuthHeader(false))
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }

    getWhitelabelConfigsByHostName(host: string): Observable<any>{
        return this.http.get(this._baseUrl+'/api/whitelabelConfig/host-feature/' + host , this.getAuthHeader(false))
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }

    getWhitelabelFeatures(): Observable<any>{
        return this.http.get(this._baseUrl+'/api/whitelabelFeature' , this.getAuthHeader(false))
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }

    //benefits
    getBenefitsByProductId(productId): Observable<any>{
        return this.http.get(this._baseUrl+'/api/benefit/' + productId , this.getAuthHeader(false))
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }

    checkPreRegisterTelemed(memberId, productId){
        return this.http.get(this._baseUrl+ `/api/ssoTelemed/sso-check-preRegister/${memberId}/${productId}` , this.getAuthHeader(false))
        .map((response : Response) => {
            return response.json();
        })
        .catch(this.handleError);  
    }
    
    activeDependentFeatureNotified(memberId: string): Observable<any>{
        return this.http.post(this._baseUrl + `/api/member/active-dependent-feature-notified/${memberId}`,{})
            .map( (res : Response)=> {return res.json()} )
            .catch( this.handleError );
    }

    //member parent
    submitAdultFromMinor(data): Observable<any>{
        return this.http.post(this._baseUrl + `/api/member/submit-adult-from-minor/`,data)
            .map( (res : Response)=> {return res.json()} )
            .catch( this.handleError );
    }

    ssoTelepetLogin(memberId, productId): Observable<any>{
        return this.http.get(this._baseUrl + `/api/ssoMyTelemedicine/sso-login/${memberId}/${productId}`)
                .map((res: Response) => {return res.json()})
                .catch(this.handleError)
    }

}


// WEBPACK FOOTER //
// ./src/app/_services/api.service.ts